import { faArrowLeft, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner, FormLabel, Row, Col, FormControl, Card, FormSelect, FormGroup } from "react-bootstrap";
import GridModelosProduto from "../Grid/GridModelosProduto";
import { toast } from "react-toastify";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import AdicionarProdutoData from "../ModalForm/AdicionarProdutoData";
import { useParams } from "react-router-dom";

interface PedidoItem {
  modelo?: string;
  descricao?: string;
  id_produto: any;
  codigo_barras?: number;
  precos?: { tamanho: string; preco_venda: string }[];
}

interface ItemData {
  id_pedido: any;
  id_produto: any;
  tamanhos: { tamanho: string, ord: any, preco_unitario: number, quantidade: number, }[];
}

interface ModalProps {
  show: boolean;
  setShow: any;
  reload: any;
  tabela: string;
  onCancel: () => void;
}

const ModalAdicionarItem: React.FC<ModalProps> = ({ show, setShow, reload, tabela, onCancel }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [gridData, setGridData] = useState<PedidoItem[]>([]);
  const [dataProduto, setDataProduto] = useState<PedidoItem | null>(null);
  const [itemData, setItemData] = useState<ItemData>({
    id_pedido: id,
    id_produto: '',
    tamanhos: []
  });

  const [dataSearch, setDataSearch] = useState({
    searchFor: "modelo",
    searchValue: "",
  });

  const handleChangeSearch = (e: React.ChangeEvent<any>) => {
    const { id, value } = e.target;
    setDataSearch((prevData) => ({
      ...prevData,
      [id]: value,
      ...(id === "searchFor" && { searchValue: "" })
    }));
    setDataProduto(null);
  };

  const handleChange = (e: React.ChangeEvent<any>, index: number) => {
    const { id, value } = e.target;

    setItemData((prevData) => {
      const newTamanhos = [...prevData.tamanhos];
      const existingIndex = newTamanhos.findIndex(t => t.tamanho === id);

      if (existingIndex !== -1) {
        newTamanhos[existingIndex] = { ...newTamanhos[existingIndex], quantidade: Number(value) };
      } else {
        const precoUnitario = dataProduto?.precos?.find(p => p.tamanho === id)?.preco_venda || 0;
        newTamanhos.push({ tamanho: id, ord: index, preco_unitario: Number(precoUnitario), quantidade: Number(value) });
      }
      const updatedData = { ...prevData, tamanhos: newTamanhos };
      console.log("itemData atualizado:", updatedData);
      return updatedData;
    });
  };

  const getData = () => {
    setLoading(true);

    api.get(`${BackEndRoutes.routes.PRODUTOS.LIST}?id_tabela=${tabela}&${dataSearch.searchFor}=${dataSearch.searchValue}`)
      .then((response) => {
        setGridData(response.data);
        setDataProduto(null);
      })
      .catch((error) => {
        console.error("Erro ao buscar o pedido", error);
        toast.error("Falha ao buscar pedido. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSave = () => {
    setLoading(true);

    api.post(BackEndRoutes.routes.PEDIDOS.ITENS.POST, itemData)
      .then(response => {
        console.log("Sucesso:", response.data);
        toast.success("Produto adicionado com sucesso!");
      })
      .catch(error => {
        console.error("Erro ao salvar o item", error);
        toast.error("Falha ao salvar item. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
        setShow(false);
        setDataProduto(null);
        setItemData({
          id_pedido: id,
          id_produto: '',
          tamanhos: []
        });
        setDataSearch({
          searchFor: "modelo",
          searchValue: "",
        });
        reload();
      });
  };

  useEffect(() => {
    if (dataProduto && dataProduto.id_produto) {
      setItemData(prevData => ({
        ...prevData,
        id_produto: dataProduto.id_produto
      }));
    }
  }, [dataProduto]);



  return (
    <Modal show={show} size="xl" onHide={onCancel}>
      <Modal.Header closeButton style={{ background: "var(--color-profile-1)", color: "black" }}>
        <Modal.Title>Adicionar Item</Modal.Title>
      </Modal.Header>
      <Modal.Body className="content">
        <Row className="mb-4">
          <Col lg={4} md={4} xs={12}>
            <FormGroup>
              <FormLabel>Pesquisar Por</FormLabel>
              <FormSelect id="searchFor" value={dataSearch.searchFor} onChange={handleChangeSearch}>
                <option value="modelo">MODELO</option>
                <option value="descricao">DESCRIÇÃO</option>
                <option value="codigo_barras">CÓDIGO DE BARRAS</option>
              </FormSelect>
            </FormGroup>
          </Col>
          <Col lg={8} md={8} xs={12}>
            <FormLabel>Pesquisar</FormLabel>
            <FormGroup className="d-flex">
              <FormControl
                type="text"
                id="searchValue"
                style={{ borderRadius: '5px 0px 0px 5px' }}
                value={dataSearch.searchValue}
                onChange={handleChangeSearch}
              />
              <Button className="btn btn-secondary" style={{ borderRadius: '0px 5px 5px 0px' }} onClick={getData}>
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <Row className={`${gridData.length === 0 ? 'd-none' : ''}`}>
          <Col>
            <GridModelosProduto
              dataGrid={gridData}
              setDataGrid={setGridData}
              setData={setDataProduto}
              searchFor={dataSearch.searchFor}
              setDataSearch={setDataSearch} />
          </Col>
        </Row>
        <div className={`${!dataProduto?.precos ? 'd-none' : ''}`}>
          <AdicionarProdutoData data={dataProduto} />
          <Row className="mt-4 ">
            {dataProduto?.precos?.map(({ tamanho, preco_venda }, index) => (
              <Col lg={4} md={6} xs={12} key={index} className="mb-3">
                <Card className="text-center" style={{ background: "#3490dc", color: "white" }}>
                  <Card.Header>
                    <Card.Title>Tamanho {tamanho}</Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <FormControl
                      id={tamanho}
                      type="text"
                      onChange={(e) => handleChange(e, index)}
                      className="col-12 text-center form-control"
                      value={itemData.tamanhos.find(t => t.tamanho === tamanho)?.quantidade || ''}
                    />
                  </Card.Body>
                  <Card.Footer>
                    <Card.Text>R$ {preco_venda}</Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="d-flex justify-content-center">
            <Button className="col-12" onClick={handleSave} disabled={!itemData.tamanhos.some(t => t.quantidade > 0) || loading}>
              Adicionar Produto
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicionarItem;
